import React, { useEffect, useState } from "react";

const dificulte = ["Ușor", "Mediu", "Greu"];

export default function AdminEditCursuri() {
  const [cursuri, setCursuri] = useState([]);
  const [loadingListe, setLoadingListe] = useState(false);
  const [errorListe, setErrorListe] = useState("");

  const [editCursId, setEditCursId] = useState(null);
  const [titlu, setTitlu] = useState("");
  const [dificultate, setDificultate] = useState(dificulte[0]);
  const [timpEstimativ, setTimpEstimativ] = useState("");
  const [slideuri, setSlideuri] = useState([""]);
  const [intrebari, setIntrebari] = useState([
    { intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" },
  ]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [errorSave, setErrorSave] = useState("");
  const [mesajSave, setMesajSave] = useState("");

  // Încarcă lista cursurilor
  const fetchCursuri = async () => {
    setLoadingListe(true);
    setErrorListe("");
    try {
      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/cursuri", {
        headers: { Authorization: "Bearer unwantedtok" },
      });
      const data = await res.json();
      if (res.ok) setCursuri(data);
      else setErrorListe(data.error || "Eroare la încărcarea cursurilor.");
    } catch {
      setErrorListe("Eroare de rețea.");
    } finally {
      setLoadingListe(false);
    }
  };

  useEffect(() => {
    fetchCursuri();
  }, []);

  // Încarcă curs pentru editare după id
    const incarcaEditareCurs = async (id) => {
    setErrorSave(""); setMesajSave("");
    setEditCursId(id);
    try {
        const res = await fetch(`https://prdp-api.suport-949.workers.dev/api/cursuri/${id}`, {
        headers: { Authorization: "Bearer unwantedtok" },
        });
        const data = await res.json();
        if (res.ok) {
        // corectare titlu cu data.curs
        setTitlu(data.curs.titlu);
        setDificultate(data.curs.dificultate);
        setTimpEstimativ(data.curs.timpestimativ);
        // procesare slideuri din obiecte în stringuri
        setSlideuri((data.slideuri && Array.isArray(data.slideuri))
            ? data.slideuri.map(s => s.continut)
            : [""]);
        // procesare întrebări conform structurii
        setIntrebari((data.intrebari && Array.isArray(data.intrebari))
            ? data.intrebari.map(q => ({
                intrebare: q.intrebare,
                varianta_a: q.variantaa,
                varianta_b: q.variantab,
                varianta_c: q.variantac,
                varianta_d: q.variantad,
                varianta_e: q.variantae || "",
                raspuns_corect: q.raspunscorect
            }))
            : [{
                intrebare: "",
                varianta_a: "",
                varianta_b: "",
                varianta_c: "",
                varianta_d: "",
                varianta_e: "",
                raspuns_corect: "a"
            }]
        );
        } else {
        setErrorSave(data.error || "Eroare la încărcarea cursului.");
        }
    } catch {
        setErrorSave("Eroare de rețea la încărcarea cursului.");
    }
    };


  // Șterge curs
  const stergeCurs = async (id) => {
    if (!window.confirm("Sigur doriți să ștergeți acest curs?")) return;
    setErrorListe("");
    try {
      const res = await fetch(`https://prdp-api.suport-949.workers.dev/api/cursuri/${id}`, {
        method: "DELETE",
        headers: { Authorization: "Bearer unwantedtok" },
      });
      const data = await res.json();
      if (data.success) {
        if (editCursId === id) resetForm();
        fetchCursuri();
      } else {
        setErrorListe(data.error || "Eroare la ștergerea cursului.");
      }
    } catch {
      setErrorListe("Eroare rețea la ștergerea cursului.");
    }
  };

  // Reset form
  const resetForm = () => {
    setEditCursId(null);
    setTitlu("");
    setDificultate(dificulte[0]);
    setTimpEstimativ("");
    setSlideuri([""]);
    setIntrebari([{ intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" }]);
    setErrorSave("");
    setMesajSave("");
  };

  // Update slide
  const updateSlide = (i, val) => {
    const s = [...slideuri];
    s[i] = val;
    setSlideuri(s);
  };
  const addSlide = () => setSlideuri([...slideuri, ""]);
  const removeSlide = (i) => setSlideuri(slideuri.filter((_, index) => index !== i));

  // Update intrebare
  const updateIntrebare = (i, field, val) => {
    const it = [...intrebari];
    it[i][field] = val;
    setIntrebari(it);
  };
  const addIntrebare = () => setIntrebari([...intrebari, { intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" }]);
  const removeIntrebare = (i) => setIntrebari(intrebari.filter((_, index) => index !== i));

  // Salvează modificările cursului (update)
  const salveazaCurs = async () => {
    setErrorSave("");
    setMesajSave("");
    if (!titlu || !dificultate || !timpEstimativ) {
      setErrorSave("Completați toate câmpurile de bază.");
      return;
    }
    setLoadingSave(true);
    try {
      const res = await fetch(`https://prdp-api.suport-949.workers.dev/api/cursuri/${editCursId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer unwantedtok" },
        body: JSON.stringify({ titlu, dificultate, timp_estimativ: timpEstimativ, slideuri, intrebari }),
      });
      const data = await res.json();
      if (data.success) {
        setMesajSave("Curs actualizat cu succes!");
        fetchCursuri();
      } else {
        setErrorSave(data.error || "Eroare la actualizarea cursului.");
      }
    } catch {
      setErrorSave("Eroare de rețea sau server.");
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h2>Administrează și Editează Cursuri</h2>

      {/* Listă cursuri */}
      <section style={{ marginBottom: 40 }}>
        <h3>Lista Cursuri</h3>
        {errorListe && <p style={{ color: "red" }}>{errorListe}</p>}
        {loadingListe ? (
          <p>Se încarcă cursurile...</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>Titlu</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>Dificultate</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>Timp estimat</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {cursuri.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", padding: 16 }}>
                    Nu există cursuri.
                  </td>
                </tr>
              )}
              {cursuri.map((curs) => (
                <tr key={curs.id}>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{curs.titlu}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{curs.dificultate}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{curs.timpestimativ}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                    <button
                      onClick={() => incarcaEditareCurs(curs.id)}
                      style={{
                        marginRight: 10,
                        backgroundColor: "#285be8",
                        color: "#fff",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: 6,
                        cursor: "pointer",
                      }}
                    >
                      Editează
                    </button>
                    <button
                      onClick={() => stergeCurs(curs.id)}
                      style={{
                        backgroundColor: "#e12424",
                        color: "#fff",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: 6,
                        cursor: "pointer",
                      }}
                    >
                      Șterge
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      {/* Formular editare curs */}
      {editCursId && (
        <section style={{
          background: "#f3f6fd",
          borderRadius: "20px",
          boxShadow: "6px 6px 18px #e3e6ee, -6px -6px 20px #f9faff",
          padding: "32px",
          maxWidth: "800px",
          margin: "auto"
        }}>
          <h3>Editare curs: {titlu || "(Nedefinit)"}</h3>
          {errorSave && <p style={{ color: "red" }}>{errorSave}</p>}
          {mesajSave && <p style={{ color: "green" }}>{mesajSave}</p>}

          <div style={{ marginBottom: 12 }}>
            <label>Titlu curs</label>
            <input
              style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
              value={titlu}
              onChange={(e) => setTitlu(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label>Dificultate</label>
            <select
              style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
              value={dificultate}
              onChange={(e) => setDificultate(e.target.value)}
            >
              {dificulte.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label>Timp estimat (ex: 2-3 ore)</label>
            <input
              style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
              value={timpEstimativ}
              onChange={(e) => setTimpEstimativ(e.target.value)}
            />
          </div>

          {/* Slide-uri */}
          <div style={{ marginBottom: 20 }}>
            <label>Slide-uri</label>
            {slideuri.map((slide, i) => (
              <div key={i} style={{ marginBottom: 10, position: "relative" }}>
                <textarea
                  style={{ width: "100%", minHeight: 55, padding: 8, borderRadius: 6, border: "1px solid #ccc" }}
                  value={slide}
                  onChange={(e) => updateSlide(i, e.target.value)}
                />
                <button
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    border: 0,
                    background: "#e64040",
                    color: "#fff",
                    borderRadius: "0 0 12px 0",
                    padding: "2px 10px",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                  disabled={slideuri.length === 1}
                  onClick={() => removeSlide(i)}
                >
                  ×
                </button>
              </div>
            ))}
            <button onClick={addSlide} style={{ marginTop: 0, padding: "5px 20px", borderRadius: 8, border: "none", background: "#285be8", color: "white", cursor: "pointer" }}>
              + Adaugă slide
            </button>
          </div>

          {/* Întrebări grilă */}
          <div>
            <label>Întrebări grilă</label>
            {intrebari.map((it, i) => (
              <div
                key={i}
                style={{
                  background: "#f7faff",
                  borderRadius: 12,
                  boxShadow: "inset 2px 2px 6px #e3e6ee, inset -2px -2px 6px #fff",
                  padding: 10,
                  marginBottom: 16,
                }}
              >
                <textarea
                  style={{ width: "100%", minHeight: 35, padding: 8, borderRadius: 6, border: "1px solid #ccc" }}
                  placeholder="Întrebare"
                  value={it.intrebare}
                  onChange={(e) => updateIntrebare(i, "intrebare", e.target.value)}
                />
                {["a", "b", "c", "d", "e"].map((opt) => (
                  <div key={opt} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <input
                      type="radio"
                      name={`raspuns_corect_${i}`}
                      checked={it.raspuns_corect === opt}
                      onChange={() => updateIntrebare(i, "raspuns_corect", opt)}
                      style={{ marginRight: 5 }}
                    />
                    <span style={{ minWidth: 60 }}>Opțiunea {opt.toUpperCase()}:</span>
                    {(opt !== "e" || it[`varianta_${opt}`]) && (
                      <input
                        style={{ width: "60%", marginBottom: 0, padding: 6, borderRadius: 6, border: "1px solid #ccc" }}
                        type="text"
                        value={it[`varianta_${opt}`]}
                        onChange={(e) => updateIntrebare(i, `varianta_${opt}`, e.target.value)}
                      />
                    )}
                  </div>
                ))}
                <button
                  type="button"
                  style={{
                    border: 0,
                    borderRadius: 8,
                    background: "#e64040",
                    color: "#fff",
                    margin: "8px 0 0 0",
                    padding: "3px 12px",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                  onClick={() => removeIntrebare(i)}
                  disabled={intrebari.length === 1}
                >
                  Șterge întrebare
                </button>
              </div>
            ))}
            <button
              onClick={addIntrebare}
              style={{ background: "#285be8", color: "#fff", border: 0, borderRadius: 8, padding: "5px 20px", cursor: "pointer" }}
            >
              + Adaugă întrebare
            </button>
          </div>

          <button
            onClick={salveazaCurs}
            disabled={loadingSave}
            style={{
              border: "none",
              borderRadius: 12,
              background: "#285be8",
              color: "#fff",
              fontWeight: "700",
              padding: "14px 0",
              width: "100%",
              fontSize: "1.08em",
              marginTop: 20,
              cursor: "pointer",
            }}
          >
            {loadingSave ? "Salvează..." : "Salvează modificările"}
          </button>
          <button
            onClick={resetForm}
            disabled={loadingSave}
            style={{
              border: "none",
              borderRadius: 12,
              background: "#aaa",
              color: "#fff",
              fontWeight: "700",
              padding: "10px 0",
              width: "100%",
              fontSize: "1.08em",
              marginTop: 10,
              cursor: "pointer",
            }}
          >
            Renunță la editare
          </button>
        </section>
      )}
    </div>
  );
}
